export default __webpack_public_path__ + "static/media/html_file_icon.96ae5aac.svg";